<div class="container-full-nav" *ngIf="navEnabled">


    <div class="container-nav nav-background navbar-fixed-top">

        <nav class="navbar navbar-left-section row">

            <button class="navbar-ra-toggle hidden-lg-up btn btn-link dropdown" type="button"
                    [class.disabled]="!buttonsEnabled()"
                    [ngClass]="{'disabled' : !buttonsEnabled()}"
                    data-toggle="dropdown"
                    id="navbar-tools-sm">
            </button>

            <span class="navbar-brand hidden-md-down"></span>

            <span class="navbar-learner col-sm-6 col-lg-4 col-xl-5">{{learnerName}}</span>

            <div class="odometer-section">

                <div class="row">

                        <a (click)="pointsEnabled() && go('summary')" class="odometer-label"
                           [class.disabled]="!pointsEnabled()"
                           [ngClass]="{'disabled' : !pointsEnabled()}">Points</a>


                    <div class="odometer">
                        <counto [countFrom]="pointService.startingPoints()" [step]="1" [duration]="200" [countTo]="0" (countoChange)="intermediate = $event"
                        class="odometer-value">
                            {{intermediate}}
                        </counto>
                    </div>
                </div>

            </div>

            <div class="tools-menu dropdown-hamburger dropdown-menu hidden-lg-up" aria-labelledby="navbar-tools" aria-haspopup="true" aria-expanded="false">

                <ul class="list-group list-group-flush">
                    <div class="arrow_box"></div>
                    <li class="list-group-item">
                        <a (click)="go('library')" class="nav-link">
                            <span class="icon icon-mylib"></span>
                            <span class="nav-link-label">Library</span>
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a (click)="openHelpModal()" class="nav-link">
                            <span class="icon icon-help"></span>
                            <span class="nav-link-label">Help</span>
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a (click)="openMicCheck()" class="nav-link">
                            <span class="icon icon-mic"></span>
                            <span class="nav-link-label">Microphone Check</span>
                        </a>
                    </li>
                    <li class="list-group-item">
                        <a (click)="openSysinfoModal()" class="nav-link">
                            <span class="icon icon-sysinfo"></span>
                            <span class="nav-link-label">System Information</span>
                        </a>
                    </li>
                    <li class="list-group-item" *ngIf="isReadingViewCurrently()">
                        <a (click)="openCreditsModal()" class="nav-link">
                            <span class="icon icon-credits"></span>
                            <span class="nav-link-label">Credits</span>
                        </a>
                    </li>
                </ul>
            </div>

        </nav>

        <nav class="navbar navbar-right-section">

            <ul class="nav navbar-nav pull-xs-right">
                <li class="nav-item nav navbar-nav hidden-md-down"
                (click)="navItemClick($event)"
                [ngClass]="{'active' : selectedItem === 'Library' && !isReadingViewCurrently() && !currentUrl.match('/summary') }">
                    <a (click)="buttonsEnabled() && go('library')"
                       [class.disabled]="!buttonsEnabled()" [ngClass]="{'disabled' : !buttonsEnabled()}"
                       class="nav-link">
                        <span class="icon icon-mylib"></span>
                        <span class="nav-link-label">Library</span>
                    </a>
                </li>
                <li class="nav-item dropdown nav navbar-nav hidden-md-down"
                [ngClass]="{'disabled' : !buttonsEnabled()}"
                (click)="navItemClick($event)">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="navbar-tools"
                       aria-haspopup="true" aria-expanded="false"
                       [class.disabled]="!buttonsEnabled()"
                       [ngClass]="{'disabled' : !buttonsEnabled()}">
                        <span class="icon icon-tools"></span>
                        <span class="nav-link-label">Tools</span>
                    </a>
                    <div class="tools-menu dropdown-menu dropdown-tools" aria-labelledby="navbar-tools">
                        <div class="arrow_box"></div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item">
                                <a (click)="openHelpModal()" class="nav-link">
                                    <span class="icon icon-help"></span>
                                    <span class="nav-link-label">Help</span>
                                </a>
                            </li>
                            <li class="list-group-item">
                                <a (click)="openMicCheck()" class="nav-link">
                                    <span class="icon icon-mic"></span>
                                    <span class="nav-link-label">Microphone Check</span>
                                </a>
                            </li>
                            <li class="list-group-item">
                                <a (click)="openSysinfoModal()" class="nav-link">
                                    <span class="icon icon-sysinfo"></span>
                                    <span class="nav-link-label">System Information</span>
                                </a>
                            </li>
                            <li class="list-group-item" *ngIf="isReadingViewCurrently()">
                                <a (click)="openCreditsModal()" class="nav-link">
                                    <span class="icon icon-credits"></span>
                                    <span class="nav-link-label">Credits</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
                <li class="nav-item nav navbar-nav hidden-md-down" [hidden]="!buttonsEnabled()">
                    <span class="nav-divider-line"></span>
                </li>
                <li class="nav-item"
                (click)="navItemClick($event)"
                [ngClass]="{'active' : selectedItem === 'Fluency' && fluencyBtnEnabled() && !isReadingViewCurrently() && !currentUrl.match('/summary') , 'disabled' : !fluencyBtnEnabled()}">
                    <a class="nav-link" (click)="openFluencyReport()"
                       [class.disabled]="!fluencyBtnEnabled()"
                       [ngClass]="{'disabled' : !fluencyBtnEnabled()}">
                        <span class="icon icon-flu"></span>
                        <span class="nav-link-label">Fluency</span>
                    </a>
                </li>
                <li class="nav-item"
                (click)="navItemClick($event)"
                [ngClass]="{'active' : selectedItem === 'Selection' && selectionBtnEnabled() && !isReadingViewCurrently() && !currentUrl.match('/summary'), 'disabled' : !selectionBtnEnabled()}">
                    <a class="nav-link" (click)="openSelectionReport()"
                       [class.disabled]="!selectionBtnEnabled()"
                       [ngClass]="{'disabled' : !selectionBtnEnabled()}">
                        <span class="icon icon-sel"></span>
                        <span class="nav-link-label">Selection</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="exit()"
                        [class.disabled]="!exitBtnEnabled()"
                        [ngClass]="{'disabled' : !exitBtnEnabled()}">
                        <span class="icon icon-exit"></span>
                        <span class="nav-link-label">Exit</span>
                    </a>


                </li>
            </ul>

        </nav>

    </div>

</div>

<credits></credits>
<help></help>
<sysinfo></sysinfo>
<microphone-check-modal></microphone-check-modal>
